
<template>
    <el-dialog title="修改个人信息" @close="close" :visible.sync="dialogmy">
        <avue-form ref="obj" v-model="obj" :rules="rules"  :option="option"></avue-form>
        <template>
                <div id="imgUp">
                    <span>图片</span>
                <img :src="imgAvater" class="card-img" id="pick-avatar"/>
                </div>
                <avatar-cropper
                    @uploaded="handleUploaded"
                    @error="handlerError"
                    trigger="#pick-avatar"
                    :upload-url="uploadUrl" />
        </template>
        <template slot="footer">
            <center>
                <el-button  @click="close">取 消</el-button>
                <el-button type="primary" @click="update">确 定</el-button>
            </center>
        </template>
    </el-dialog>
</template>
<script>
import {updateMyInfos} from '@/api/admin/user'
import {dealElement} from '@/util/util'
import {objKeySort} from '@/util/ajaxsign'
import {getImgLink,getImgLinksplit,apiLink} from '@/config/env'
import {phone,email,validatePass,validatePass2} from "@/util/Format"
import AvatarCropper from "vue-avatar-cropper"
export default {
    components: { AvatarCropper },
    name: 'table_user',
    data() {
        return {
            //使用该属性触发视图更新
            imgAvater:'',
            uploadUrl:'',
            userId : '',
            dialogmy : false,
            obj : {
                name : '',
                phone : '',
                sex : '',
                email :'',
                avatar : ''
            },
            rules : {},
            option:{
                emptyBtn:false,
                submitBtn:false,
                submitText : '确定',
                column: [ {
                  label: "昵称",
                  prop: "name",
                  disabled : false,
                  span:24,
                  rules : [
                    {required: true, message: '请输入昵称', trigger: 'blur' },
                    {min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur'}
                  ]
                },{
                    label: "性别",
                    prop: "sex",
                    type: "select",
                    span:24,
                    dicData: [{ value: 1, label: '男'}, { value: 0, label: '女'  }]
                },{
                    label: "邮箱",
                    prop: "email",
                    span:24,
                    rules: [{ validator: email, trigger: 'blur' }]
                },
                ]
            },
        }
    },
    created() {
    },
    methods: {
        handleUploaded(resp) {
            if(resp.code == 200){
              this.obj.avatar = getImgLink(resp.data.filePath);
              this.imgAvater = this.obj.avatar;
            }
        },
        handlerError(message, type, xhr) {
            console.log("Oops! Something went wrong...");
        },
        //展示弹出层
        dialog(data){
            this.title = data;
            this.dialogmy = true;
            this.getcompany()
        },
         //获取企业信息
        getcompany(){
            this.session = JSON.parse(window.sessionStorage.getItem("userInfo"));
            this.obj.name = this.session.name;
            this.obj.phone = this.session.phone;
            this.obj.sex =  this.session.sex;
            this.obj.email =  this.session.email;
            this.obj.avatar =this.session.avatar?getImgLink(this.session.avatar):this.session.headimgurl?this.session.headimgurl:'/img/default-avatar.png';
            this.imgAvater = this.obj.avatar;
            this.uploadUrl = apiLink('/files/fileUpload')
            console.log(this.obj.avatar)
        },

        //修改数据展示
        setobj(data){
            this.obj = data;
        },


        //对表单数据进行初始化
        rolecolum(data,dict){
            for(var i=0;i<this.option.column.length;i++){
                if(this.option.column[i].prop == data){
                    this.option.column[i].dicData = dict;
                }
            }
        },

        close(){
            this.dialogmy = false;
            this.$refs.obj.resetForm();
        },

        //修改数据
        update(){
            //获取用户信息
            this.session = JSON.parse(window.sessionStorage.getItem("userInfo"));
            //判断头像是否为默认头像
            if((this.obj.avatar=='/img/default-avatar.png')){
                //是默认头像
                this.obj.avatar = undefined;
            }else{
                this.obj.avatar = getImgLinksplit(this.obj.avatar);
            }
            this.$refs.obj.validate(vaild=>{
                if(vaild){
                    updateMyInfos(objKeySort(dealElement(this.obj))).then((options) => {
                    window.sessionStorage.removeItem("userInfo");
                    window.sessionStorage.setItem( "userInfo", JSON.stringify(options.data.data));
                    this.$message({
                        title: '成功',
                        message: '修改成功',
                        type: 'success',
                        duration: 2000
                    })
                    this.close();
                    this.$emit('refresh');
                    })
                }
            })
        }
    }
}
</script>

<style>
.card-img {
    width: 178px;
    height: 178px;
    display: block;
}
#imgUp img{
    margin-left: 80px
}
#imgUp span{
    margin-left: 40px
}
</style>

